import {defineMessages} from 'react-intl'
import R from 'ramda'

import getSuggestions from '../api/suggestions'
import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: "Something bad happened", 
    defaultMessage: "Something bad happened"
  },
  message: {
    id: "Failed to fetch suggestions", 
    defaultMessage: "Failed to fetch suggestions"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onComplete = dispatch => (err, res) => {
  if(err) {
    dispatch(addNotification(notification))
    return console.error("failed to fetch suggestions", err)
  }
  dispatch({type: 'update_suggestions', payload: res})
} 
export default () => (dispatch, getState) => {
  const criterion = R.pick(['viewPort'], getState()) 
  const criterionForAPi = {
    viewPort: {
      topLeft: criterion.viewPort[1],
      bottomRight: criterion.viewPort[0],
    },
  }
  getSuggestions(criterionForAPi, onComplete(dispatch))
}



/** WEBPACK FOOTER **
 ** ./app/actions/updateSuggestions.js
 **/